function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m17.02 11.103 6.75.981-4.885 4.762 1.153 6.724L14 20.395 7.962 23.57l1.153-6.724-4.885-4.762 6.75-.98L14 4.985l3.02 6.117Zm-7.7-2.285-8.457 1.23a1 1 0 0 0-.555 1.705l6.12 5.966-1.444 8.424a1 1 0 0 0 1.45 1.054L14 23.22l7.565 3.977a1 1 0 0 0 1.451-1.054l-1.444-8.424 6.12-5.966a1 1 0 0 0-.554-1.706l-8.459-1.229-3.782-7.664a1 1 0 0 0-1.794 0L9.321 8.818Z"
  }));
};
var componentName = 'StarOutlined';
export var StarOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
StarOutlined.displayName = componentName;